import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply Shubh theme to body
document.body.classList.add('shubh-theme');

// Hide loading fallback when React starts
const hideLoading = () => {
  const fallback = document.getElementById('loading-fallback');
  if (fallback) fallback.style.display = 'none';
};

// Global error handler to show errors on screen for debugging
window.onerror = function(msg, url, line, col, error) {
  console.error('Nakshatra Error:', msg, url, line);
  const fallback = document.getElementById('loading-fallback');
  const msgEl = document.getElementById('loading-message');
  if (fallback && msgEl) {
    msgEl.innerHTML = '<span style="color:#ff6b6b;">Error loading app</span><br><br><small style="color:#888;">' + msg + '</small><br><br><a href="/" style="color:#D4AF37;">Tap to reload</a>';
  }
  return false;
};

try {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  // Hide loading after a short delay to ensure React has rendered
  setTimeout(hideLoading, 100);
} catch (error) {
  console.error('Nakshatra React Error:', error);
  const msgEl = document.getElementById('loading-message');
  if (msgEl) {
    msgEl.innerHTML = '<span style="color:#ff6b6b;">Failed to load</span><br><br><a href="/" style="color:#D4AF37;">Tap to reload</a>';
  }
}
